import { HelpersModule } from "../helpers/helpers";
import { TrackingModule } from "../helpers/TrackingHelper";

const helpersModule = new HelpersModule();
const trackingModule = new TrackingModule();

var enquiryForm = {
    setupSpecialityDropdown: function () {
        var ajaxUrl = apilocation + "Finders/SuggestSpecialties/";
        var html = "";
        fetch(ajaxUrl)
            .then(function (response) {
                response.json().then(data => ({
                    data: data,
                    status: response.status
                })
                ).then(res => {
                    var data = JSON.parse(res.data);
                    $.each(data.Suggestions, function (index, item) {
                        html += "<li data-value='" + item.NodeId + "'>" + item.Display + "</li>";
                    });
                    $("#ir35specialityDropdown .results").append(html);
                });
            });
    },
    getParsleyConfig: function () {
        return {
            errorsContainer: function (pEle) {
                var $err = pEle.$element.parents('.ir35-js-enquiry-form__tabs__content__inner__container__element').find('.error');
                return $err;
            },
            classHandler: function (el) {
                return el.$element.closest('.ir35-js-enquiry-form__tabs__content__inner__container__element');
            },
            uiEnabled: true
        };
    },
    customValidator: function () {

        var $dobErrorRequiredContainer = $('.js-date-required-concatenate'),
            $dobContainer = $('.enquiry-form__tabs__content__inner__container__element--dob--required');

        $('.js-enquiry-form__submit').on("click", function () {

            var thisForm = $(this).parents(".js-enquiry-form");

            $dobErrorRequiredContainer = $(thisForm).find('.js-date-required-concatenate');
            $dobContainer = $(thisForm).find('.enquiry-form__tabs__content__inner__container__element--dob--required');

            var day = parseInt($(thisForm).find(".js-dob-day-required").val(), 10);
            var month = parseInt($(thisForm).find(".js-dob-month-required").val(), 10);
            var year = parseInt($(thisForm).find(".js-dob-year-required").val(), 10);

            if (isNaN(day) || isNaN(month) || isNaN(year)) {

                $dobErrorRequiredContainer.text('Please complete this information.').show();
                $dobContainer.addClass('enquiry-form__tabs__content__inner__container__element--error');


            } else {
                $dobErrorRequiredContainer.hide();
                $dobContainer.removeClass('enquiry-form__tabs__content__inner__container__element--error');

            }

        });

        var $form = $(".ir35-js-enquiry-form");

        $form.find(".js-dob-day, .js-dob-month, .js-dob-year").on("change", function () {

            var thisForm = $(this).parents(".js-enquiry-form");

            $dobErrorRequiredContainer = $(thisForm).find('.js-date-required-concatenate');
            $dobContainer = $(thisForm).find('.enquiry-form__tabs__content__inner__container__element--dob--required');

            var day = parseInt($(thisForm).find(".js-dob-day").val(), 10);
            var month = parseInt($(thisForm).find(".js-dob-month").val(), 10);
            var year = parseInt($(thisForm).find(".js-dob-year").val(), 10);

            if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                $(thisForm).find(".js-dob-concatenate").val(day + "/" + month + "/" + year);
            }

            if (isNaN(day) || isNaN(month) || isNaN(year)) {

                $dobErrorRequiredContainer.text('Please complete this information.').show();
                $dobContainer.addClass('enquiry-form__tabs__content__inner__container__element--error');


            } else {
                $dobErrorRequiredContainer.hide();
                $dobContainer.removeClass('enquiry-form__tabs__content__inner__container__element--error');

            }
        });

        // new appointment for verify eror on select field
        $form.find(".js-dob-day-required, .js-dob-month-required, .js-dob-year-required").on("change", function () {

            var thisForm = $(this).parents(".js-enquiry-form");

            $dobErrorRequiredContainer = $(thisForm).find('.js-date-required-concatenate');
            $dobContainer = $(thisForm).find('.enquiry-form__tabs__content__inner__container__element--dob--required');

            var day = parseInt($(thisForm).find(".js-dob-day-required").val(), 10);
            var month = parseInt($(thisForm).find(".js-dob-month-required").val(), 10);
            var year = parseInt($(thisForm).find(".js-dob-year-required").val(), 10);

            if (isNaN(day) || isNaN(month) || isNaN(year)) {

                $dobErrorRequiredContainer.text('Please complete this information.').show();
                $dobContainer.addClass('enquiry-form__tabs__content__inner__container__element--error');


            } else {
                $dobErrorRequiredContainer.hide();
                $dobContainer.removeClass('enquiry-form__tabs__content__inner__container__element--error');

            }


        });

        window.Parsley.addValidator('date', {
            requirementType: 'string',
            validateString: function (value, requirements, parsleyInstance) {

                var $row = $(parsleyInstance.$element).parents(".js-enquiry-form__tabs__content__inner__container__element");

                var day = parseInt($row.find(".js-dob-day").val(), 10);
                var month = parseInt($row.find(".js-dob-month").val(), 10);
                var year = parseInt($row.find(".js-dob-year").val(), 10);

                if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {

                    var age = helpersModule.getAge(day, month, year);

                    return age > 17;
                }
            },
            messages: {
                en: 'You must be over 18 to submit an enquiry',
            }
        });
    },
    emailValidator: function () {

        window.Parsley.addValidator('customequalto', {
            requirementType: 'string',

            validateString: function (value, elem, parsleyInstance) {

                $(elem).on("keyup", _.debounce(function () {
                    parsleyInstance.validate();
                }, 100));

                if (value.length > 0 && $(elem).length > 0) {
                    return value.toLowerCase() === $(elem).val().toLowerCase();
                }
                return false;
            }
        });
    },

    removeLastComma: function (str) {
        return str.replace(/,\s*$/, "")
    },

    submitForm: function (thisForm) {

        var that = this;
        var form = $(thisForm).parsley(that.getParsleyConfig());
        var $submitButton = $(thisForm).find(".ir35-js-enquiry-form__submit");

        if (form.validate()) {

            $submitButton.prop('disabled', true);
            var $spinner = thisForm.find('.ir35-enquiry-form__button-container__spinner');
            $spinner.addClass('ir35-enquiry-form__button-container__spinner--on');

            var selectedHospital = thisForm.find('#select-hospital');
            var selectedHospitalValue = $(selectedHospital).find('option:selected').text();

            var selectedSpeciality = thisForm.find('#specialityDropdown').find(".dropdown-toggle").text();
            var title = thisForm.find('#title').val();
            var firstName = thisForm.find('#first-name').val();
            var surname = thisForm.find('#surname').val();          
            var emailAddress = thisForm.find('#enquiry-email').val(); // CHECK NAME
            var phoneNum = thisForm.find('#phone-number').val();
            var physiciancode = thisForm.find('#physician-code').val();
            var comments = thisForm.find('#comments').val();


            var enquiryFields = {
               
                "title": title,
                "firstName": firstName,
                "surname": surname,            
                "Location": selectedHospitalValue,
                "speciality": selectedSpeciality,
                "physicianCode": physiciancode,
                "emailAddress": emailAddress,                
                "phoneNum": phoneNum,
                "comments": comments,
               
            };
           
                enquiryFields.nearestHospitalName = $(selectedHospital).find('option:selected').text();
                enquiryFields.nearestHospitalId = selectedHospitalValue;
                postForm(enquiryFields, thisForm, $submitButton, $spinner);
           
        }
    },
   
    init: function () {
        var isEnquiryForm = $("#ir35-enquiry-form").length > 0;
        if (!isEnquiryForm) {
            return;
        }
        var that = this;      
        that.emailValidator();

        that.setupSpecialityDropdown();
        $(".ir35-js-enquiry-form__submit").on('click', function (e) {
            e.preventDefault();
            var thisForm = $(this).parents(".ir35-js-enquiry-form");
            
            that.submitForm(thisForm);

            setTimeout(function () {                

            }, 2000);


        });

        $(".ir35-js-enquiry-form").each(function (index) {

            if ($(this).parsley !== null) {
                $(this).parsley(that.getParsleyConfig()).on('field:validated', function () { });
            }

        });

    }

};

var postForm = function (enquiryFields, thisForm, $submitButton, $spinner) {

    $.ajax({
        type: "POST",
        url: apilocation + 'EnquiryFormApi/IR35SendEnquiry',
        data: JSON.stringify(enquiryFields),
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    }).done(function (data) {

       postToThankYou();    


    });
};

var postToThankYou = function () {

    var thankYouPostForm = $("#ir35-thankYouPost");
    
    thankYouPostForm.submit();
};



function ir35enquiryFormModule() {
    $(window).on('load', function () {
   
        if ($(".ir35-js-inpageEnquiryForm").length !== 0) {
            enquiryForm.init();
         
        }  

    });
}

export { ir35enquiryFormModule };